<template>
  <v-container style="width:800px;">
    <v-card>
      <v-container>
        <v-card-title>取引先・ブランド関連メンテナンス</v-card-title>
        <form>
          <v-flex xs12 sm12 style="margin-top: 20px;">
            <v-select
              v-model="selectSupplier"
              :items="suppliers"
              label="取引先"
              item-text="supplierName"
              item-value="supplierCode"
              :sort-by="['supplierCode']"
              :sort-desc="[false]"
              return-object
            ></v-select>
          </v-flex>
          <v-flex xs12 sm12 style="margin-top: 20px;">
            <v-select
              v-model="selectBrand"
              :items="brands"
              label="ブランド"
              item-text="brandName"
              item-value="brandId"
              :sort-by="['brandId']"
              :sort-desc="[false]"
              return-object
            ></v-select>
          </v-flex>
          <v-flex xs12 sm12>
            <v-btn block color="success" dark @click="newItem()">
              <v-icon class="ma-2" :loading="loading2" :disabled="loading2" dark small>save</v-icon>追加する
            </v-btn>
          </v-flex>
        </form>
      </v-container>
    </v-card>

    <br />

    <v-card>
      <v-container>
        <v-card-title>取引先・ブランド関連一覧</v-card-title>

        <v-data-table
          :headers="headers"
          :items="supplierBrands"
          class="elevation-1"
          :custom-sort="customSort"
          hide-actions
        >
          <template v-slot:items="props">
            <td>
              <v-checkbox v-model="props.item.isDeleted" value="1" primary hide-details></v-checkbox>
            </td>
            <td class="text-xs-left">{{ props.item.supplierName }}</td>
            <td class="text-xs-left">{{ props.item.brandName }}</td>
          </template>
        </v-data-table>
      </v-container>
    </v-card>

    <v-layout row wrap style="margin-top:  30px; margin-bottom: 50px;">
      <v-flex xs12 sm5>
        <v-btn block color="#4C728A" dark :to="{ name: 'admin/new-admin-menu' }">
          <v-icon color="black" left>home</v-icon>{{ $t('home-btn') }}
        </v-btn>
      </v-flex>
      <v-flex xs12 sm2></v-flex>
      <v-flex xs12 sm5>
        <v-btn block color="error" dark @click="deleteContacts()">
          <v-icon dark left>delete_forever</v-icon>選択した取引先・ブランド関連を削除する
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ServerApiCallService from '@/services/ServerApiCallService.js'
import { exists } from 'fs'
export default {
  created() {
    console.log('created')
    ServerApiCallService.setAppJs(this.$parent.$parent.$parent)
    this.refreshContacts()
  },
  methods: {
    customSort(items, index, isDesc) {
      console.log('custom sort. supplierName asc > brandName asc')
      items.sort((a, b) => {
        if (a.supplierName < b.supplierName) {
          return -1
        } else if (a.supplierName > b.supplierName) {
          return 1
        }

        if (a.brandName < b.brandName) {
          return -1
        } else if (a.brandName > b.brandName) {
          return 1
        }
        return 0
      })
      return items
    },
    refreshContacts() {
      let thisObj = this
      thisObj.loading = true

      ServerApiCallService.brands()
        .then(response => {
          thisObj.brands = response.data.brands
          thisObj.loading = false
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })

      ServerApiCallService.suppliers()
        .then(response => {
          thisObj.suppliers = response.data.suppliers
          thisObj.loading = false
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })

      ServerApiCallService.supplierBrands()
        .then(response => {
          thisObj.supplierBrands = response.data.supplierBrands
          thisObj.loading = false
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    newItem() {
      console.log('add Item')
      let thisObj = this

      let addSupplierBrand = {
        supplierCode: thisObj.selectSupplier.supplierCode,
        brandId: thisObj.selectBrand.brandId,
        supplierName: thisObj.selectSupplier.supplierName,
        brandName: thisObj.selectBrand.brandName
      }

      let exitsSameData = false

      thisObj.supplierBrands.forEach(function(row) {
        if (
          row.supplierCode === addSupplierBrand.supplierCode &&
          row.brandId === addSupplierBrand.brandId
        ) {
          exitsSameData = true
        }
      })

      if (exitsSameData) {
        this.$parent.$parent.$parent.showResultDialog(
          'この取引先とブランド名の組み合わせはすでに登録されています',
          null,
          true
        )
        return
      }

      let request = {
        supplierCode: this.selectSupplier.supplierCode,
        brandId: this.selectBrand.brandId
      }

      let sendContext = {
        hasDialogComponent: this.$parent.$parent.$parent
      }

      if (this.selectSupplier.supplierCode === '#') {
        this.$parent.$parent.$parent.showErrorDialog(
          '取引先が選択されていません'
        )
        thisObj.loading2 = false
        return
      }
      if (this.selectBrand.brandId === '#') {
        this.$parent.$parent.$parent.showErrorDialog(
          'ブランドが選択されていません'
        )
        thisObj.loading2 = false
        return
      }

      ServerApiCallService.supplierBrandPost(request, sendContext)
        .then(response => {
          let newSupplierBrands = [] // thisObj.supplierBrandsの内容をここに移していく。途中で新規追加したレコードを差し込む
          let isCompleteAdd = false

          thisObj.supplierBrands.forEach(function(row) {
            if (
              !isCompleteAdd &&
              row.supplierCode > addSupplierBrand.supplierCode
            ) {
              // 新規追加した取引先コードが小さければ追加
              newSupplierBrands.push(addSupplierBrand)
              isCompleteAdd = true
            } else if (
              !isCompleteAdd &&
              row.supplierCode === addSupplierBrand.supplierCode
            ) {
              if (row.brandId > addSupplierBrand.brandId) {
                //新規追加したブランドコードが小さければ追加
                newSupplierBrands.push(addSupplierBrand)
                isCompleteAdd = true
              }
            }
            newSupplierBrands.push(row)
          })

          // 新規追加される取引先・ブランドが中間で差し込まれなかった場合、最後にpushする
          if (!isCompleteAdd) {
            newSupplierBrands.push(addSupplierBrand)
          }

          this.supplierBrands = newSupplierBrands
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    deleteContacts() {
      console.log('delete contacts')
      let thisObj = this
      thisObj.loading2 = true

      let request = {
        supplierBrands: []
      }
      // TODO 現状isDeletedがfalseの場合nullで飛ぶ
      this.supplierBrands.forEach(function(row) {
        if (row.isDeleted === '1') {
          request.supplierBrands.push(row)
        }
      })

      let sendContext = {
        hasDialogComponent: this.$parent.$parent.$parent
      }

      ServerApiCallService.supplierBrandsDelete(request, sendContext)
        .then(() => {
          console.log('delete completed')
          thisObj.loading2 = false
          thisObj.refreshContacts()
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    close() {
      this.dialog = false
    }
  },
  data() {
    return {
      loader: null,
      loading: true,
      loading1: false,
      loading2: false,

      notice: '',
      switch1: '0',

      dialog: false,

      brands: [],
      suppliers: [],
      supplierBrands: [],

      selectBrand: {
        brandId: '#',
        brandName: '選択してください'
      },

      selectSupplier: {
        supplierCode: '#',
        supplierName: '選択してください'
      },

      headers: [
        { text: '選択', value: 'selceted', sortable: false },
        { text: '取引先', value: 'suppliers', sortable: false },
        { text: 'ブランド', value: 'barands', sortable: false }
      ],
      businessContacts: []
    }
  }
}
</script>

<style lang="scss" scoped></style>
